if (!customElements.get('product-swatches')) {
  class ProductSwatches extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.productContainer = this.closest('#product-container');
      this.productContainerDescription = this.productContainer?.querySelector('.product-single__learn-more-description');
      this.productContainerDescriptionCopy = this.productContainerDescription?.innerHTML;
      this.swatchElements = this.querySelectorAll('.product-swatch');
      this.setData();
      this.setDefaultSwatch();
      this.setEventListeners();
    }

    setData() {
      const scriptTag = this.querySelector('script[type="application/json"]:first-of-type');
      this.data = scriptTag ? JSON.parse(scriptTag.innerHTML) : null;
      if (scriptTag) this.removeChild(scriptTag);
    }

    setEventListeners() {
      this.addEventListener('change', async (event) => {
        if (event.target.classList.contains('product-swatch__input')) {
          await this.handleSwatchChange(event.target);
        }
      });

      this.swatchElements.forEach((swatchElement) => {
        swatchElement.addEventListener('mouseenter', this.handleMouseEnter.bind(this, swatchElement));
        swatchElement.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      });
    }

    handleMouseEnter(swatchElement, event) {
      const swatchInput = swatchElement.querySelector('.product-swatch__input');
      const swatchData = this.getSwatchFromHandle(swatchInput.value);
      if (!swatchData) return;

      const decodedHTML = swatchData.description.replace(/\\"/g, '"');
      this.productContainerDescription.innerHTML = this.createTempDiv(decodedHTML).innerHTML;
    }

    handleMouseLeave(event) {
      this.productContainerDescription.innerHTML = this.productContainerDescriptionCopy;
    }

    setDefaultSwatch() {
      const checkedSwatchInput = this.querySelector('.product-swatch__input:checked');
      if (!checkedSwatchInput) {
        this.currentSwatch = null;
        return;
      }
      this.setCurrentSwatch(checkedSwatchInput.value);
    }

    async handleSwatchChange(swatchInput) {
      this.setCurrentSwatch(swatchInput.value);
      await this.fetchSwatchProductHTML(this.currentSwatch.url);
    }

    getSwatchFromHandle(swatchHandle) {
      return this.data?.swatches?.find((s) => s.handle === swatchHandle) || null;
    }

    setCurrentSwatch(swatchHandle) {
      this.currentSwatch = this.getSwatchFromHandle(swatchHandle);
    }

    async fetchSwatchProductHTML(url) {
      console.log(`product-swatches fetchSwatchProductHTML(${url})`, this);
      if (typeof url !== 'string' || url.length < 1) return;

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const html = await response.text();
        const tempDiv = this.createTempDiv(html);
        const newContent = tempDiv.querySelector('.product-template__container.page-width')?.innerHTML;
        const newReviewsContent = tempDiv.querySelector('.product-reviews__container.page-width')?.innerHTML;

        if (newContent) {
          this.productContainer.innerHTML = newContent;
          this.productContainerDescription = this.productContainer.querySelector('.product-single__learn-more-description');
          this.productContainerDescriptionCopy = this.productContainerDescription?.innerHTML;
        }

        const reviewsContainer = document.querySelector('.product-reviews__container.page-width');
        if (reviewsContainer && newReviewsContent) {
          reviewsContainer.innerHTML = newReviewsContent;
        }

        this.reinitializeDebutSections();

        // Update the URL without reloading the page
        history.pushState({}, '', url);
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    }

    createTempDiv(html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv;
    }

    reinitializeDebutSections() {
      window.sections = new theme.Sections();
      sections.register('product', theme.Product);
      sections.register('product-template', theme.Product);
      sections.register('product-template-bundle', theme.Product);
      productScripts();
      sections.register('product-recommendations', theme.ProductRecommendations);
      sellingPlan();
      window.okeWidgetApi.initAllWidgets();
      initSubscriptionGroups();
      this.initializeStickyMedia();
      document.dispatchEvent(new CustomEvent("content:swap"));
    }

    initializeStickyMedia() {
      const elements = {
        imageWrapper: document.querySelector('.product-single__media-container'),
        productMedia: document.querySelector('.product-single__media-container .product-single__media'),
        sentinelPixel: document.querySelector('.product-single__media-container .sentinel-pixel'),
        announcement: document.querySelector('#shopify-section-announcement-bar'),
        header: document.querySelector('#shopify-section-header')
      };

      const attachStickyMediaClass = () => {
        if (!elements.imageWrapper) return;
        elements.imageWrapper.classList.add('sticky-media');
        adjustMediaTop();
      };

      const adjustMediaTop = () => {
        if (!elements.productMedia) return;
        let newTop = 'unset';
        if (window.innerWidth > 768) {
          const sentinelPosition = elements.sentinelPixel.getBoundingClientRect().top + window.scrollY;
          newTop = `${sentinelPosition - elements.productMedia.offsetHeight - elements.announcement.offsetHeight}px`;
        }
        elements.productMedia.style.top = newTop;
      };

      const initSentinelObserver = () => {
        if (!elements.sentinelPixel) return;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && window.scrollY < elements.announcement.offsetHeight) return;
            if (entry.isIntersecting && entry.target === elements.sentinelPixel) {
              if (elements.productMedia) {
                attachStickyMediaClass();
                observer.disconnect();
              }
            }
          });
        }, { threshold: 1 });

        observer.observe(elements.sentinelPixel);
      };

      initSentinelObserver();
    }
  }

  customElements.define('product-swatches', ProductSwatches);
}
